import { Fragment } from '@wordpress/element'
import { Button, TextControl } from '@wordpress/components'
import React from 'react'
import { handlePageClick } from '../PhotoSearch/Functions'
import classNames from 'classnames'

const Pagination = ({
  inApprovalFooter,
  includePageCount,
  inFooter,
  setState,
  state,
  varNames
}) => {
  return (
    <div className={classNames('obsidian-moon-pagination', ((inApprovalFooter) ? 'in-approval-footer' : ''))}>
      {(() => {
        if (includePageCount) {
          return (
            <div className='page-count'>Count: {state.items.length}</div>
          )
        }
      })()}
      <div className='page-list'>
        {(() => {
          return (
            <Fragment>
              <Button
                className='page'
                onClick={() => handlePageClick({
                  inFooter,
                  newPage: 1,
                  setState: (state) => setState(state),
                  state,
                  varNames
                })}
              >
                1
              </Button>
              {(() => {
                if (state.page > 3) {
                  return (
                    <div className='page-spacer'>...</div>
                  )
                }

                return ''
              })()}
              {(() => {
                return (
                  <Fragment>
                    {(() => {
                      if ((state.page - 1) > 1) {
                        return (
                          <Button
                            className='page'
                            onClick={() => handlePageClick({
                              inFooter,
                              newPage: (state.page - 1),
                              setState: (state) => setState(state),
                              state,
                              varNames
                            })}
                          >
                            {state.page - 1}
                          </Button>
                        )
                      }

                      return ''
                    })()}
                    {(() => {
                      if (state.page !== 1 && state.page !== state.lastPage) {
                        return (
                          <Button
                            className='page'
                            onClick={() => handlePageClick({
                              inFooter,
                              newPage: state.page,
                              setState: (state) => setState(state),
                              state,
                              varNames
                            })}
                          >
                            {state.page}
                          </Button>
                        )
                      }

                      return ''
                    })()}
                    {(() => {
                      if ((state.page + 1) < state.lastPage) {
                        return (
                          <Button
                            className='page'
                            onClick={() => handlePageClick({
                              inFooter,
                              newPage: state.page + 1,
                              setState: (state) => setState(state),
                              state,
                              varNames
                            })}
                          >
                            {state.page + 1}
                          </Button>
                        )
                      }

                      return ''
                    })()}
                  </Fragment>
                )
              })()}
              {(() => {
                if (state.page < (state.lastPage - 2)) {
                  return (
                    <div className='page-spacer'>...</div>
                  )
                }

                return ''
              })()}
              {(() => {
                if (state.lastPage > 1) {
                  return (
                    <Button
                      className='page'
                      onClick={() => handlePageClick({
                        inFooter,
                        newPage: state.lastPage,
                        setState: (state) => setState(state),
                        state,
                        varNames
                      })}
                    >
                      {state.lastPage}
                    </Button>
                  )
                }

                return ''
              })()}
              <TextControl
                className='page-input'
                value={state.page}
                onChange={(newPage) => handlePageClick({
                  inFooter,
                  newPage,
                  setState: (state) => setState(state),
                  state,
                  varNames
                })}
              />
            </Fragment>
          )
        })()}
      </div>
    </div>
  )
}

export default Pagination
